import { createEmptyContext } from '../../../../utils/create-empty-context';
export const MemberPhotoUploaderContextInstance = createEmptyContext();
/**
 * Utility method to create `MemberPhotoUploaderContext` object from `MemberPhotoUploaderProps`.
 */
export function mapMemberPhotoUploaderContext(props) {
    return {
        displayText: props.displayText,
        assets: props.assets
    };
}
